import * as React from "react";
import {
  Image,
  View,
  ImageBackground,
  TouchableOpacity,
  ActivityIndicator,
  Alert,
  Dimensions,
  ToastAndroid,
} from "react-native";
import { launchCamera, launchImageLibrary } from "@utils/imagePickerCompat";
import checkPermissions from "./checkPermissions";
import colors from "@constants/color";
import CloseIcon from "@assets/svg/CloseIcon";
import ImagesModal from "./ImagesModal";
import Label from "../../Label";
import Button from "../Button";
import AddPhotoButton from "../AddPhotoButton";
import { normalize } from "../../../../../components/ProductDisplayUnit/metrics";
import uploadImage from "../../../utils/uploadImage";
import { uploadPrivateImage } from "@services/api";

const Images = ({ formItem = {}, onSubmit }) => {
  const [srcMap, setSrcMap] = React.useState([]);
  const [modalVisible, setModalVisible] = React.useState(false);
  const { label } = formItem;

  const remove = (id) => {
    const itemIdx = srcMap.findIndex((src) => src.id === id);
    if (itemIdx !== -1) {
      srcMap.splice(itemIdx, 1);
      setSrcMap(srcMap.slice());
      onSubmit(srcMap.map((s) => s.url));
    }
  };

  const updateSrc = (newMap) => {
    setSrcMap([...srcMap, newMap]);
  };

  const updateUrlRef = React.useRef();
  updateUrlRef.current = (id, url) => {
    const itemIdx = srcMap.findIndex((s) => s.id === id);
    if (itemIdx !== -1) {
      srcMap[itemIdx] = {
        ...srcMap[itemIdx],
        url,
      };
      setSrcMap(srcMap.slice());
      onSubmit(srcMap.map((s) => s.url));
    }
  };

  const onClickImageBlock = async () => {
    try {
      await checkPermissions();
      if (srcMap.length > 3) {
        ToastAndroid.showWithGravity(
          "Can upload only upto 4 images",
          ToastAndroid.SHORT,
          ToastAndroid.CENTER,
        );
        return;
      }
      Alert.alert(
        "Upload Photo",
        "आप कहाँ से फ़ोटो चुनना चाहते हैं?",
        [
          {
            text: "कैमरे से",
            onPress: () => {
              launchCamera(
                {
                  mediaType: "photo",
                  maxHeight: 500,
                  maxWidth: 700,
                  quality: 0.4,
                },
                onImageSelect,
              );
            },
          },
          {
            text: "गैलरी से",
            onPress: () => {
              launchImageLibrary(
                {
                  mediaType: "photo",
                  maxHeight: 500,
                  maxWidth: 700,
                  quality: 0.4,
                },
                onImageSelect,
              );
            },
          },
        ],
        { cancelable: true },
      );

      const onImageSelect = async (response) => {
        try {
          if (response.didCancel) {
            return;
          } else if (response.error) {
            console.log("ImagePicker Error: ", response.error);
            return;
          }
          const source = { uri: `${response.uri}` };
          const id = require("react-native-uuid").default.v1();
          updateSrc({ source, id });
          const data = new FormData();
          data.append("image", {
            name: response.fileName,
            type: response.type,
            uri: response.uri,
          });
          const { data: uploadData } = await uploadImage(data);
          updateUrlRef.current(id, uploadData.url);
        } catch (e) {
          console.log("upload image rror", e);
          ToastAndroid.showWithGravity(
            "error with uploading image",
            ToastAndroid.SHORT,
            ToastAndroid.CENTER,
          );
        }
      };
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Label label={label} type="images" />
      <View
        style={{
          borderColor: "#e6e6e6f0",
          minHeight: 145,
        }}
      >
        <View style={{ marginVertical: 5, flex: 1 }}>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {srcMap.map(({ url, source, id }, index) =>
              url || source ? (
                <ImageBackground
                  key={index}
                  style={{
                    height: (Dimensions.get("screen").width - 66) / 2,
                    width: (Dimensions.get("screen").width - 66) / 2,
                    borderRadius: 6,
                    borderWidth: 2,
                    borderColor: "rgba(0, 0, 0, 0.2)",
                    backgroundColor: "white",
                    alignItems: "center",
                    justifyContent: "center",
                    borderStyle: "solid",
                    marginBottom: 10,
                    overflow: "hidden",
                  }}
                  source={url ? { uri: url } : source}
                >
                  <TouchableOpacity
                    onPress={() => remove(id)}
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      backgroundColor: "#ffffff66",
                      borderRadius: 15,
                      borderColor: "#e6e6e6",
                      borderWidth: 1,
                      width: 30,
                      height: 30,
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                    }}
                  >
                    <View>
                      <CloseIcon />
                      {source && !url && (
                        <View
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.1)",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ActivityIndicator
                            size="large"
                            color={colors.primary}
                          />
                        </View>
                      )}
                    </View>
                  </TouchableOpacity>
                </ImageBackground>
              ) : null,
            )}
            {srcMap.length < 4 && (
              <AddPhotoButton
                label="फोटो डालें"
                // onPress={() => setModalVisible(true)}
                onPress={onClickImageBlock}
              />
            )}
          </View>
        </View>
      </View>
      {/*  <ImagesModal
        onRequestClose={() => setModalVisible(false)}
        visible={modalVisible}
        srcMap={srcMap}
        remove={remove}
        updateSrc={updateSrc}
        updateUrlRef={updateUrlRef}
    /> */}
    </>
  );
};

export default Images;
